import axiosInstance from './axiosInstance';

// Centralizes all auth-related API calls in one place.
// Login.jsx just calls loginRequest() rather than building the axios call inline —
// keeps the component focused on UI, not API details.
export async function loginRequest(email, password, userType = 'driver') {
  const response = await axiosInstance.post('/auth/login.php', {
    email,
    password,
    user_type: userType,
  });
  return response.data; // { success, token, user }
}